export type LeadGateMode = 'none' | 'soft' | 'hard'

export function resolveLeadGate(input: {
  postGate?: string | null
  siteDefault?: string | null
}): LeadGateMode {
  const post = String(input.postGate || 'inherit')
  if (post === 'none' || post === 'soft' || post === 'hard') return post
  const site = String(input.siteDefault || 'none')
  if (site === 'soft' || site === 'hard') return site
  return 'none'
}

export function clampGatePercentage(value: unknown, fallback = 60): number {
  const n = Number(value)
  if (!Number.isFinite(n)) return fallback
  return Math.max(10, Math.min(90, Math.round(n)))
}

export function splitGatedContent<T>(
  blocks: T[],
  percentage: number,
  lengthOf: (block: T) => number,
): { visible: T[]; gated: T[] } {
  if (blocks.length === 0) return { visible: [], gated: [] }
  const total = blocks.reduce((sum, block) => sum + Math.max(1, lengthOf(block)), 0)
  const cutoff = Math.max(1, Math.ceil(total * (clampGatePercentage(percentage) / 100)))
  let acc = 0
  const visible: T[] = []
  const gated: T[] = []
  for (const block of blocks) {
    if (acc >= cutoff && visible.length > 0) gated.push(block)
    else {
      visible.push(block)
      acc += Math.max(1, lengthOf(block))
    }
  }
  if (gated.length === 0 && visible.length > 1) {
    return { visible: visible.slice(0, -1), gated: visible.slice(-1) }
  }
  return { visible, gated }
}
